import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z","key":"svg-0"}],["path",{"d":"M8 7l4 6l4 -6","key":"svg-1"}],["path",{"d":"M12 17l0 -4","key":"svg-2"}]]

const IconBrandYcombinator = createReactComponent('outline', 'brand-ycombinator', 'BrandYcombinator', __iconNode);

export default IconBrandYcombinator;